import Backbone from 'backbone';
import ko from 'knockout';
import tmpl from '@bingads-webui-campaign-legacy/auto-targets/template/create/specificWebpagePreview.pug';
import SpecificTargetView from '@bingads-webui-campaign-legacy/auto-targets/view/specific-target';
import TargetPreviewView from '@bingads-webui-campaign-legacy/auto-targets/view/create/targetPreview';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');

export default class View extends Backbone.View {
  initialize(options = {}) {
    this.options = options;
  }
  get events() {
    return {
      'click .arrow-button': 'selectTarget',
      'click .preview': 'renderPreview',
    };
  }
  render() {
    this.$el.html(tmpl({ i18n }));
    this.specificTarget = new SpecificTargetView({
      el: this.$('.conditions'),
      setting: this.options.setting,
      isShowUrlOnly: this.options.isShowUrlOnly,
    }).render();
    ko.applyBindings(this.specificTarget.viewmodel, this.$('.summary')[0]);

    this.on('update:setting', (setting) => {
      this.specificTarget.trigger('update:setting', setting);
    });
    return this;
  }
  show() {
    this.$el.show();
    return this;
  }
  hide() {
    this.$el.hide();
    return this;
  }
  selectTarget() {
    this.trigger('selectTarget', {
      conditions: this.specificTarget.viewmodel.items(),
      type: 'specificpage',
      shouldCheckArgumentOperandFormat: this.options.shouldCheckArgumentOperandFormat,
    });
  }
  renderPreview() {
    const targetClass = 'popover-operand';

    if (this.previewView) {
      this.previewView.close();
    }

    if (this.$(`.${targetClass}`).length > 0) {
      this.$(`.${targetClass}`).remove();
    }

    this.$('.preview-operand').append(`<span class="${targetClass}" />`);

    this.previewView = new TargetPreviewView({target: this.$(`.${targetClass}`), conditions: this.specificTarget.viewmodel.items}).render();
  }
  reset() {
    this.specificTarget.viewmodel.reset();
  }
}
